<template>
    <div class="paas-breadcrumb">
        <el-breadcrumb separator="/"
            :class="{ 'el-breadcrumb--intent': intent }"
        >
            <el-breadcrumb-item v-for="route of routes"
                :key="getRouteKey(route)"
                :to="route.to"
            >
                {{ route.name }}
            </el-breadcrumb-item>
        </el-breadcrumb>
        <div class="slot-right">
            <slot />
        </div>
    </div>
</template>

<script>
import _ from 'lodash'

export default {
    name: 'Breadcrumb',
    props: {
        routes: {
            type: Array,
            required: true
        },
        intent: Boolean
    },
    methods: {
        getRouteKey(route) {
            return _.uniqueId(route.name);
        }
    }
}
</script>
